"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSO_FORMAT_MAP = exports.MONTHS = exports.DAYS = void 0;
/**
 * 表示周相关字符
 */
exports.DAYS = [
    ['Sun', 'Sunday', '星期天', '周日'],
    ['Mon', 'Monday', '星期一', '周一'],
    ['Tue', 'Tuesday', '星期二', '周二'],
    ['Wed', 'Wednesday', '星期三', '周三'],
    ['Thu', 'Thursday', '星期四', '周四'],
    ['Fri', 'Friday', '星期五', '周五'],
    ['Sat', 'Saturday', '星期六', '周六'],
];
/**
 * 表示月相关字符
 */
exports.MONTHS = [
    ['J', 'Jan', 'January'],
    ['F', 'Feb', 'February'],
    ['M', 'Mar', 'March'],
    ['A', 'Apr', 'April'],
    ['M', 'May', 'May'],
    ['J', 'Jun', 'June'],
    ['J', 'Jul', 'July'],
    ['A', 'Aug', 'August'],
    ['S', 'Sep', 'September'],
    ['O', 'Oct', 'October'],
    ['N', 'Nov', 'November'],
    ['D', 'Dec', 'December'],
];
/**
 * 其余相关字符
 */
exports.MSO_FORMAT_MAP = {
    Standard: '#,##0.00',
    Scientific: '0.00E+00',
    Percent: '0.00%',
    'Short Date': 'yyyy/m/d',
    'Long Date': 'yyyy"年"m"月"d"日"',
    'General Date': 'yyyy/m/d hh:mm',
    'Medium Date': 'd-mmm-yy',
    'Long Time': 'h:mm:ss AM/PM',
    'Medium Time': 'h:mm AM/PM',
    'Short Time': 'hh:mm',
    'AM/PMh"时"mm"分"': '上午/下午h"时"mm"分"',
    'AM/PMh"时"mm"分"ss"秒"': '上午/下午h"时"mm"分"ss"秒"',
    Fixed: '#,##0.00_ ;@',
};
//# sourceMappingURL=date-const.js.map